import React, { useRef , useState} from 'react';
import { Toast } from 'primereact/toast';
import { Form, Field } from 'react-final-form';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { useNavigate } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import './MotDePasseOublie.css'
import { oubli } from '../../Data/user_service';
// import { LoadScriptNext } from '@react-google-maps/api';
import { ProgressSpinner } from 'primereact/progressspinner';
export const MotDePasseOublie = () => {
    const toast = useRef(null);
    const[Load, setLoad]=useState(false)
    const navigate = useNavigate()
    const toLowerCase = (value) => (value ? value.toLowerCase() : "");
    const [isSubmitting, setIsSubmitting] = useState(false); // For spinner
    const onSubmit = async (data) => {
        setIsSubmitting(true); // Start spinner
       oubli(data)
           .then(()=> {
            setLoad(true)
            setIsSubmitting(false); // Start spinner
        setTimeout(() => {
            navigate('/');
          }, 7500);
          },) 
       .catch (( error) => {
                setIsSubmitting(false); // Stop spinner on error
             
                console.error(error);
                toast.current.show({ severity: 'error', 
                summary: 'Une erreur est survenue', 
                detail: 'Cette adresse mail n’a pas été reconnue, nous vous invitons à vous rapprocher de nos équipes', 
                life: 6500 });
    
    
    
            })
     
     
    }

    const validate = (data) => {
        let errors = {};

      
        if (!data.email) {
            errors.email = 'Adresse mail requise.';
        }
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z0-9]{2,}$/i.test(data.email)) {
            errors.email = 'Adresse mail invalide';
        }
        return errors;
    }
    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta) => {
        return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
    };
    return (

        <div className="grid loginPage">
        <div className="login" >
            <Toast ref={toast}  />
           
         
            <p className="presentation lg:col-2  lg:col-offset-2 "> GexOnline est l'offre digitale du Groupe <a href="https://gexpertise.fr" target="_blank" className="LinkGex">GEXPERTISE</a> pour une information immobilière connectée proposant une interface simple et personnalisée. Retrouvez tous vos livrables en quelques clics.</p>

            <Card className="lg:col-2 lg:col-offset-1 motdepass cardLogin">
                    {Load ? (
                        <div className="cardMotdepasse">
                            <p
                                style={{
                                    paddingTop: '20%',
                                    textAlign: 'center',
                                    lineHeight: '30px',
                                }}
                            >
                                Les instructions de réinitialisation du mot de
                                passe ont été envoyées à l'adresse mail
                                indiquée<br />
                                Vous allez être redirigé vers l'écran de
                                connexion.
                            </p>
                        </div>
                    ) : isSubmitting ? (
                        <div
                            className="loading-container"
                            aria-live="polite"
                            style={{
                                textAlign: 'center',
                                paddingTop: '20%',
                            }}
                        >
                            <ProgressSpinner
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    display: 'block',
                                    margin: '0 auto',
                                }}
                            />
                        </div>
                    ) : (
                        <div className="cardMotdepasse">
                            <p>
                                Pour réinitialiser votre mot de passe,
                                renseignez ci-dessous l'adresse mail associée à
                                votre compte GexOnline
                            </p>
                            <Form
                                onSubmit={onSubmit}
                                initialValues={{ email: '' }}
                                validate={validate}
                                render={({ handleSubmit }) => (
                                    <form
                                        onSubmit={handleSubmit}
                                        className="p-fluid"
                                    >
                                        <Field
                                        format={toLowerCase}
                                        parse={toLowerCase}
                                            name="email"
                                            render={({ input, meta }) => (
                                                <div className="p-field">
                                                    <span className="p-float-label p-input-icon-right">
                                                        <InputText
                                                            id="email"
                                                            {...input}
                                                            className={classNames(
                                                                {
                                                                    'p-invalid':
                                                                        isFormFieldValid(
                                                                            meta
                                                                        ),
                                                                }
                                                            )}
                                                        />
                                                        <label
                                                            htmlFor="email"
                                                            className={classNames(
                                                                {
                                                                    'p-error':
                                                                        isFormFieldValid(
                                                                            meta
                                                                        ),
                                                                }
                                                            )}
                                                        >
                                                            Adresse mail*
                                                        </label>
                                                    </span>
                                                    {getFormErrorMessage(
                                                        meta
                                                    )}
                                                </div>
                                            )}
                                        />
                                        <Button
                                            type="submit"
                                            label="Soumettre"
                                            className="p-mt-2 connect"
                                            disabled={isSubmitting} // Disable button while submitting
                                        />
                                    </form>
                                )}
                            />
                        </div>
                    )}
                </Card>
            </div>
        </div>
    );
};
